import { colors } from "../../Styles";

export function BirthDate({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <g>
        <path d="M238.4,32.3h-18.9v17.6c0,7.2-5.8,13-13,13h-1.2c-7.2,0-13-5.8-13-13v-17.6h-100.5v17.6c0,7.2-5.8,13-13,13h-1.2c-7.2,0-13-5.8-13-13v-17.6h-18.9c-12,0-21.7,9.8-21.7,21.7v192.8c0,12,9.8,21.7,21.7,21.7h192.8c12,0,21.7-9.8,21.7-21.7V54.1c0-12-9.8-21.7-21.7-21.7h0ZM253.3,246.9c0,8.2-6.7,14.9-14.9,14.9h-9.8l24.7-24.7v9.8ZM253.3,221.5h-23c-1.2,0-8.4,0-13,5.8-4.3,5.5-4.3,9.5-4.2,11.6v22.9H45.6c-8.2,0-14.9-6.7-14.9-14.9V105.3h222.7v116.2h0Z"/>
        <rect x="67" y="17.8" width="21.9" height="41.2" rx="10.4" ry="10.4"/>
        <path d="M205.4,17.8h1.1c5.7,0,10.4,4.7,10.4,10.4v20.4c0,5.7-4.7,10.4-10.4,10.4h-1.1c-5.7,0-10.4-4.7-10.4-10.4v-20.4c0-5.7,4.7-10.4,10.4-10.4Z"/>
      </g>
      <g>
        <rect x="78.6" y="227.6" width="129.1" height="10.7" rx="5.4" ry="5.4"/>
        <path d="M152.9,156.8c0-2.1-1.7-3.8-3.8-3.8h-12c-2.1,0-3.8,1.7-3.8,3.8v16.5h19.6v-16.5Z"/>
        <path d="M143.1,150.8s8.1,1.3,8.4-6.7c.2-8-5.8-10.7-6.7-15.6-.9-4.9-1.7-5.1-1.7-5.1,0,0-.8.2-1.7,5.1s-6.9,7.6-6.7,15.6c.2,8,8.4,6.7,8.4,6.7Z"/>
        <path d="M110.1,192c14.7,23.1,31.8.4,31.8.4,14.4,23.2,31.8-.6,31.8-.6,11.3,16.3,22.1,8.5,27.1,3.2v-6.8c0-13.8-9.6-9.5-58.4-9.5s-57-4.3-57,9.5v10.3c12.3,11.4,24.7-6.5,24.7-6.5Z"/>
        <path d="M200.8,223.9v-16.3c-14.8,13.1-27.2-3-27.2-3-16.4,17.8-32.1.1-32.1.1-17.7,17.7-32.6.4-32.6.4-8.8,10.6-20.1,7.3-23.5,6v12.7c1.5-1.5,115.4,0,115.4,0Z"/>
      </g>
    </svg>
  );
}
